import { TableSortLabel, type TableSortLabelProps } from "@mui/material";

/** The room MUI keeps for a sort arrow, shown or not: 18 px and 4 px each side. */
export const SORT_ICON_SPACE = 26;

const CENTERED_SX = {
  "&::before": { content: '""', width: SORT_ICON_SPACE, flexShrink: 0 },
} as const;

/** A column's sort label. In a centred column the arrow sits right of the name,
 * so the same room on its left keeps the name over the values. */
export default function SortLabel({
  centered = false,
  ...props
}: Omit<TableSortLabelProps, "sx"> & { centered?: boolean }) {
  return <TableSortLabel {...props} sx={centered ? CENTERED_SX : undefined} />;
}
